import { render } from "./CreateScoreCards.vue?vue&type=template&id=09ad214c&scoped=true"
import script from "./CreateScoreCards.vue?vue&type=script&lang=js"
export * from "./CreateScoreCards.vue?vue&type=script&lang=js"

import "./CreateScoreCards.vue?vue&type=style&index=0&id=09ad214c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ad214c"]])

export default __exports__